import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Image,
  Input,
  Tag,
  Tooltip,
  Select,
  message,
  Skeleton
} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import Main from "../../../components/layout/Main";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import apiPath from "../../../constants/apiPath";
import moment from "moment";
import useDebounce from "../../../hooks/useDebounce";
import SingleImageUpload from "../../../components/SingleImageUpload";
import ShowTotal from "../../../components/ShowTotal";
import notfound from "../../../assets/images/not_found.png";
import ImportForm from "../../../components/ImportForm";

const Search = Input.Search;
const Option = Select.Option;

const S3_BUCKET = "carwash-s3";
const REGION = "eu-north-1";
const ACCESS_KEY = "AKIA5FTZEKCY6QNUX77Q";
const SECRET_ACCESS_KEY = "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";

const config = {
  dirName: "brand",
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
};

function Index() {
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 300);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { confirm } = Modal;
  const [importVisible, setImportVisible] = useState(false);

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ?</Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => (
        <Image width={60} height={50} src={image ? image : notfound} />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) =>
        name ? <span className="cap">{name}</span> : "-",
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (_, { type }) => type?.name ?? "-",
    },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        let color = is_active ? "green" : "red";
        return (
          <a>
            <Tag
              onClick={(e) => showConfirm(_id)}
              color={color}
              key={is_active}
            >
              {is_active ? "Active" : "Inactive"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("DD-MM-YYYY");
      },
    },
    {
      title: "Action",
      fixed: "right",
      render: (_, record) => {
        return (
          <>
            <Tooltip title="Update Brand" color={"purple"} key={"updatebrand"}>
              <Button
                title="Edit"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i className="fa fa-light fa-pen"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: apiPath.statusCarBrand + "/" + record,
      method: "GET",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : null;
    request({
      url:
        apiPath.listCarBrand +
        `?status=${filterActive ? filterActive.join(",") : ""}&page=${
          pagination ? pagination.current : 1
        }&limit=${
          pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
        }));
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  return (
    <Main>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Vehicle Brand"
              extra={
                <>
                  <Search
                    size="large"
                    onChange={onSearch}
                    onPressEnter={onSearch}
                    value={searchText}
                    placeholder="Search By Name"
                  />
                  <Button
                    title="Import"
                    onClick={(e) => {
                      setImportVisible(true);
                      setSearchText("");
                    }}
                  >
                    <i className="fas fa-cloud-upload-alt"></i>
                    &nbsp;&nbsp;Import
                  </Button>
                  <Button
                    onClick={(e) => {
                      setVisible(true);
                      setSearchText("");
                    }}
                  >
                    Add Vehicle Brand
                  </Button>
                </>
              }
            >
              <h4 className="text-right mb-1">
                {pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}
              </h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <AddFrom
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      {importVisible && (
        <ImportForm
          path={apiPath.importBrand}
          sectionName={"Brand"}
          show={importVisible}
          hide={() => setImportVisible(false)}
          existingData={list}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </Main>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [selectedType, setSelectedType] = useState("");
  const [typeLoading, setTypeLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState([]);
  const [types, setTypes] = useState([]);
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // getType();
    if (!data) return;
    form.setFieldsValue({ ...data });
    data.image ? setFile([data.image]) : setFile([]);
    data.image ? setImage([data.image]) : setImage([]);
  }, [data]);
  const getType =  () => {
     setTypeLoading(true);
    request({
      url: apiPath.listCarType,
      method: "GET",
      onSuccess: (data) => {
        setTypes(data.data.list.docs);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
     setTypeLoading(false);
  };

   useEffect(  () => {
     getType();
  }, []);

  const handleTypeChange = (type) => {
    setSelectedType(type);
  };

  const selectTemplate = () => {
    if (data) {
      return (
        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: "Please Enter the type!" }]}
        >
          <div className="d-none">{data.type.name}</div>
          <Select
            showSearch
            placeholder="Select Vehicle Type"
            defaultValue={data ? data.type.name : undefined}
            optionFilterProp="name"
            onChange={handleTypeChange}
            options={types.map((type) => ({
              value: type._id,
              label: type.name,
            }))}
          ></Select>
        </Form.Item>
      );
    } else {
      return (
        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: "Please Enter the type!" }]}
        >
          <Select
            showSearch
            placeholder="Select a type"
            optionFilterProp="name"
            onChange={handleTypeChange}
            options={types.map((type) => ({
              value: type._id,
              label: type.name,
            }))}
          ></Select>
        </Form.Item>
      );
    }
  };

  const onCreate = (values) => {
    const { name, type } = values;
    let payload = {};
    setLoading(true);
    payload.name = name;
    payload.type = selectedType ? selectedType : data.type._id;
    if (file) {
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append("image", file);
      payload = formData;
    }else{
      payload.image="";
    }
    request({
      url: `${
        data
          ? apiPath.addEditCarBrand + "/" + data._id
          : apiPath.addEditCarBrand
      }`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Update Vehicle Brand" : "Create a New Vehicle Brand"}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Brand"
              name="name"
              rules={[
                { required: true, message: "Please Enter the brand!" },
                {
                  max: 50,
                  message: "Brand should not contain more then 50 characters!",
                },
                {
                  min: 2,
                  message: "Brand should contain atleast 1 characters!",
                },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Brand Name" />
            </Form.Item>
          </Col>
          <Col span={24}>{selectTemplate()}</Col>

          <Col span={24}>
            <SingleImageUpload
              dataImage={data}
              removeApi={apiPath.removeBrandImage}
              editApi={apiPath.editBrandImage}
              refreshData={refresh}
              onChange={(file) => {
                setFile(file);
              }}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Index;
